import script from "./Agencies.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agencies.vue?vue&type=script&setup=true&lang=ts"

import "./Agencies.vue?vue&type=style&index=0&id=674b352a&lang=css"

const __exports__ = script;

export default __exports__